import gql from 'graphql-tag';

export const integrationMicrosoftTeamsFragment = gql`
  fragment integrationMicrosoftTeamsFragment on IntegrationMicrosoftTeams {
    dokkioClass
    id
    accountID
    syncFolderRemoteID
    syncFolderPath
  }
`;
export default integrationMicrosoftTeamsFragment;
